import { render, staticRenderFns } from "./SingleWord.vue?vue&type=template&id=7702d936&scoped=true&"
import script from "./SingleWord.vue?vue&type=script&lang=js&"
export * from "./SingleWord.vue?vue&type=script&lang=js&"
import style0 from "./SingleWord.vue?vue&type=style&index=0&id=7702d936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7702d936",
  null
  
)

export default component.exports